/* datas */
import { GetBkgLogo } from '../Functions/GetBkgLogo.js';
import { LogoImgAttraction } from '../../../Files/LogoImgAttraction.js';
import { GetDateLongFR } from '../Functions/GetDates.js';
/* document */
import { BlockLink } from '../Blocks/BlockLink.js';
import { BlockStatus } from '../Blocks/BlockStatus.js';

export const BlockLogoArchives = (props) => {
    const item = props.item;
    const name = item.aname;
    const route = item.aroute;
    const created = GetDateLongFR(item.created);
    const closed = GetDateLongFR(item.closed);
    const src = LogoImgAttraction('icon', item.cslug, item.aslug);
    const bkg = GetBkgLogo(route);
    return (
        <div className={`logo ${bkg}`}>
            <BlockStatus status={item.status} bkg={bkg} />
            <a className="icon" href={route} alt={name} title={name}>
                <img className="img" src={src} title={name} alt={name} loading="lazy" />
            </a>
            <div className="legend">
                <div className="title">{name}</div>
                <div className="block-created">
                    <div className="created">{created}</div>
                    <div className="created">{closed}</div>
                </div>
                <BlockLink label="link-true" href={item.proute} name={item.pname} />
                <BlockLink label="link-true" href={item.croute} name={item.cname} />
            </div>
        </div>
    )
}